<template>
  <div class="account-register-candidate">
    <BaseAlert v-if="error" v-model="error" class="mb-3 _warning" />
    <RegisterCandidateForm />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RegisterCandidateForm from '../../components/register-candidate/RegisterCandidateForm';

export default {
  name: 'AccountRegisterCandidate',
  components: {
    RegisterCandidateForm,
  },
  computed: {
    ...mapGetters({
      error: 'candidate/register/error',
    }),
  },
};
</script>
